import {
    createContext,
    useContext,
    useEffect
} from "react";
import type {
    PopoverLayoutContextType,
    PopoverContextType
} from "./type";
import {
    warnOnce
} from "../../utils/development";

export const PopoverContext = createContext<PopoverContextType | undefined>(undefined);

export const PopoverLayoutContext = createContext<PopoverLayoutContextType>({
    isSheet: false
});

export const usePopoverContext = ({
    part
}: {
    part: string;
}): PopoverContextType | undefined => {
    const context = useContext(PopoverContext);

    useEffect(() => {
        if(context) {
            return;
        }

        warnOnce({
            message: `Popover.${part}: must be rendered inside <Popover>.`
        });
    }, [
        context,
        part
    ]);

    return context;
};
